<div
  class="w-full max-w-[1280px] mx-auto h-fit px-[20px] md:px-[40px] py-[64px] md:py-[128px] flex flex-col gap-[32px] md:gap-[64px] bg-white justify-center items-center"
>
  <div
    class="text-[20px] leading-7 md:text-[32px] md:leading-12 font-bold text-[var(--p-primary-400)]"
  >
    {{ 'PARTNERS' }}
  </div>
  <div
    class="text-[32px] leading-12 md:text-[48px] md:leading-16 font-bold text-[var(--p-primary-900)] text-center"
  >
    {{ 'home.partners' | translate }}
  </div>
  <img [src]="getPartners" alt="partners" class="w-full" />
</div>
